const types = {
	//Get Template name
	GET_SAMPLE_CATEGORIES_START: "GET_SAMPLE_CATEGORIES_START",
	GET_SAMPLE_CATEGORIES_SUCCESS: "GET_SAMPLE_CATEGORIES_SUCCESS",
	GET_SAMPLE_CATEGORIES_ERROR: "GET_SAMPLE_CATEGORIES_ERROR",
	GET_SAMPLE_CATEGORIES_RESET: "GET_SAMPLE_CATEGORIES_RESET",

	//Create Template name
	CREATE_SAMPLE_CATEGORIES_START: "CREATE_SAMPLE_CATEGORIES_START",
	CREATE_SAMPLE_CATEGORIES_SUCCESS: "CREATE_SAMPLE_CATEGORIES_SUCCESS",
	CREATE_SAMPLE_CATEGORIES_ERROR: "CREATE_SAMPLE_CATEGORIES_ERROR",
	CREATE_SAMPLE_CATEGORIES_RESET: "CREATE_SAMPLE_CATEGORIES_RESET",

	//delete Template name
	DELETE_SAMPLE_CATEGORIES_START: "DELETE_SAMPLE_CATEGORIES_START",
	DELETE_SAMPLE_CATEGORIES_SUCCESS: "DELETE_SAMPLE_CATEGORIES_SUCCESS",
	DELETE_SAMPLE_CATEGORIES_ERROR: "DELETE_SAMPLE_CATEGORIES_ERROR",
	DELETE_SAMPLE_CATEGORIES_RESET: "DELETE_SAMPLE_CATEGORIES_RESET",

	//update Template name
	UPDATE_SAMPLE_CATEGORIES_START: "UPDATE_SAMPLE_CATEGORIES_START",
	UPDATE_SAMPLE_CATEGORIES_SUCCESS: "UPDATE_SAMPLE_CATEGORIES_SUCCESS",
	UPDATE_SAMPLE_CATEGORIES_ERROR: "UPDATE_SAMPLE_CATEGORIES_ERROR",
	UPDATE_SAMPLE_CATEGORIES_RESET: "UPDATE_SAMPLE_CATEGORIES_RESET",

	//single item  name
	SINGLE_SAMPLE_CATEGORIES_START: "SINGLE_SAMPLE_CATEGORIES_START",
	SINGLE_SAMPLE_CATEGORIES_SUCCESS: "SINGLE_SAMPLE_CATEGORIES_SUCCESS",
	SINGLE_SAMPLE_CATEGORIES_ERROR: "SINGLE_SAMPLE_CATEGORIES_ERROR",
	SINGLE_SAMPLE_CATEGORIES_RESET: "SINGLE_SAMPLE_CATEGORIES_RESET",
};

export default types;
